import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { AuthorizedReceivedVouchersProvaider } from "./Context";
import TableVoucherAuthorized from "./Table";
import Filters from "./filters";
import { useSelector } from 'react-redux';

const useStyles = makeStyles(() => ({
    root: {
        paddingTop: '50px',
        flexGrow: 1,
        paddingLeft: '3%',
        paddingRight: '3%',
        marginBottom: '50px',
        paddingBottom: '50px',
    },
}));


const VoucherReceived = () => {

    const classesView = useStyles();
    const rucEnterprise = useSelector(state => state.user.ruc) ;

    return (
        <AuthorizedReceivedVouchersProvaider>
            <div className={classesView.root}>
                <Filters />
                <TableVoucherAuthorized  rucEnterprise={rucEnterprise}/>
            </div>
        </AuthorizedReceivedVouchersProvaider>
    );
}
export default VoucherReceived;